import React, { FC, memo } from 'react';
import { FormControl, FormGroup, FormLabel } from 'react-bootstrap';
import cls from './TariffReferralSettings.module.scss';

type TariffReferralSettingsProps = {
  referrerBonusTokens: number;
  setReferrerBonusTokens: (tokens: number) => void;
  referrerBonusError?: string;
  inviteeBonusTokens: number;
  setInviteeBonusTokens: (tokens: number) => void;
  inviteeBonusError?: string;
};

const TariffReferralSettings: FC<TariffReferralSettingsProps> = memo((props) => {
  const {
    referrerBonusTokens,
    setReferrerBonusTokens,
    referrerBonusError,
    inviteeBonusTokens,
    setInviteeBonusTokens,
    inviteeBonusError,
  } = props;

  return (
    <div className={cls.Container} data-testid="tariff-referral-settings">
      <h4 className="title-4">Referral program</h4>
      <p className={cls.Hint}>
        Tokens granted once per referral, when an invited consumer first pays for this tariff. 0
        grants nothing to that side.
      </p>
      <FormGroup className="position-relative">
        <FormLabel htmlFor="referrerBonusTokens" className="input-title-text">
          Bonus for the one who invited, tokens
        </FormLabel>
        <FormControl
          type="number"
          name="referrerBonusTokens"
          id="referrerBonusTokens"
          min={0}
          value={referrerBonusTokens}
          isInvalid={!!referrerBonusError}
          onChange={(event) => setReferrerBonusTokens(Number(event.target.value))}
        />
        <FormControl.Feedback type="invalid" tooltip>
          {referrerBonusError}
        </FormControl.Feedback>
      </FormGroup>
      <FormGroup className="position-relative">
        <FormLabel htmlFor="inviteeBonusTokens" className="input-title-text">
          Bonus for the invited one, tokens
        </FormLabel>
        <FormControl
          type="number"
          name="inviteeBonusTokens"
          id="inviteeBonusTokens"
          min={0}
          value={inviteeBonusTokens}
          isInvalid={!!inviteeBonusError}
          onChange={(event) => setInviteeBonusTokens(Number(event.target.value))}
        />
        <FormControl.Feedback type="invalid" tooltip>
          {inviteeBonusError}
        </FormControl.Feedback>
      </FormGroup>
    </div>
  );
});

export default TariffReferralSettings;
